"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_delivery__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "d96757e1-d6c3-4281-85de-9ea73abee1e3",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc68f27b-7b3e-461d-9ccb-e8bc241ea47d",
    x1: 163.31,
    y1: -95.98,
    x2: 163.31,
    y2: -4.07,
    gradientTransform: "matrix(0.63, -0.63, 0.86, 0.86, 68.93, 246.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "delivery-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "fd7fee41-eff9-466a-96a4-bea104ce1228",
    "data-name": "Business_ic_hi 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.9,87.37l-10-30A2,2,0,0,0,164,56H116l0,72h44a16,16,0,0,0,16-16V88A2,2,0,0,0,175.9,87.37Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,40H32A16,16,0,0,0,16,56v56a16,16,0,0,0,16,16h84V56A16,16,0,0,0,100,40Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,88h39.5l-7.09-21.26c-.54-1.63-1.57-2.74-3.29-2.74H128a4,4,0,0,0-4,4V84A4,4,0,0,0,128,88Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,88h39.5l-7.09-21.26c-.54-1.63-1.57-2.74-3.29-2.74H128a4,4,0,0,0-4,4V84A4,4,0,0,0,128,88Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,96h-4a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,126H116v2h44a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,126Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.14,126H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h84v-2H34.14Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,108a20,20,0,0,0-20,19.36,16,16,0,0,0,4.47.64H68A20,20,0,0,0,48,108Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,108a20,20,0,0,0-19.5,15.61L116,128h40A20,20,0,0,0,136,108Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,144a16,16,0,1,1,16-16A16,16,0,0,1,48,144Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,128a8,8,0,1,1-8-8A8,8,0,0,1,56,128Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,142a16,16,0,0,1-15.95-15c0,.33-.05.66-.05,1a16,16,0,0,0,32,0c0-.34,0-.67-.05-1A16,16,0,0,1,48,142Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.84,128a16,16,0,0,0,16-16v-3.21L123.55,56H116l0,72Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#bc68f27b-7b3e-461d-9ccb-e8bc241ea47d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,144a16,16,0,1,1,16-16A16,16,0,0,1,136,144Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,128a8,8,0,1,1-8-8A8,8,0,0,1,144,128Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,128a8,8,0,1,1-8-8A8,8,0,0,1,56,128Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144,128a8,8,0,1,1-8-8A8,8,0,0,1,144,128Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136,142a16,16,0,0,1-15.95-15c0,.33-.05.66-.05,1a16,16,0,1,0,32,0c0-.34,0-.67-.05-1A16,16,0,0,1,136,142Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })));
}

var _default = ic_delivery__dark;
exports.default = _default;